module.exports = __webpack_public_path__ + "static/img/our-people-we-live-diversity-inclusion.8700d59.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/our-people/our-people-we-live-diversity-inclusion.jpg
// module id = 7Bwz
// module chunks = 0